<template>
    <footer>
        <div class="container">
            <div class="row align-items-center justify-content-md-between mb-3">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        Corner Development
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <div class="copyright">ABN: 60883647110</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
